(() => {
  if (customElements.get('ml-load-more')) return;
  const key = () => 'ml-books-v1:' + location.pathname + location.search;
  let restoring = false;
  class MLLoadMore extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick = (event) => {
        const link = event.target.closest('[data-load-next]');
        if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.autoPaused = false;
        this.observer?.disconnect();
        this.load(link);
      });
      this.autoObserve();
    }
    autoObserve() {
      if (!('IntersectionObserver' in window) || this.autoPaused || !this.querySelector('[data-load-next]')) return;
      this.querySelector('[data-load-next]').style.display = 'none';
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting) || this.busy || restoring) return;
        const link = this.querySelector('[data-load-next]');
        if (!link) return;
        this.observer.disconnect();
        this.dataset.autoLoads = String(Number(this.dataset.autoLoads || 0) + 1);
        this.load(link, true);
      }, { rootMargin: '0px 0px 300px 0px' });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.controller?.abort();
      this.observer?.disconnect();
    }
    async load(link, automatic = false) {
      if (this.busy) return;
      this.busy = true;
      const label = link.textContent;
      const grid = document.getElementById('product-grid');
      const originalLocation = location.href;
      const url = new URL(link.href);
      url.searchParams.set('section_id', this.dataset.section);
      link.setAttribute('aria-disabled', 'true');
      this.setAttribute('aria-busy', 'true');
      link.textContent = this.dataset.loading;
      this.querySelector('[data-load-error]').hidden = true;
      this.controller = new AbortController();
      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Load failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = doc.getElementById('product-grid');
        const control = doc.querySelector('ml-load-more');
        if (!nextGrid || !control) throw new Error('Invalid section');
        if (!this.isConnected || location.href !== originalLocation || document.getElementById('product-grid') !== grid) return;
        const cards = Array.from(nextGrid.children);
        if (!cards.length) throw new Error('Empty section');
        const existing = new Set(Array.from(grid.querySelectorAll('.card-wrapper')).map(el => el.querySelector('a[href*="/products/"]')?.getAttribute('href')).filter(Boolean));
        const added = [];
        cards.forEach(card => {
          const href = card.querySelector('.card-wrapper a[href*="/products/"]')?.getAttribute('href');
          if (href && existing.has(href)) return;
          if (href) existing.add(href);
          card.querySelectorAll('.scroll-trigger').forEach(el => el.classList.add('scroll-trigger--cancel'));
          card.classList.add('scroll-trigger--cancel');
          grid.append(card);
          added.push(card);
        });
        this.dataset.shown = String(Number(this.dataset.shown) + added.length);
        this.querySelector('[data-load-count]').textContent = this.dataset.countLabel.replace('[shown]', this.dataset.shown).replace('[total]', this.dataset.count);
        const next = control.querySelector('[data-load-next]');
        if (next) {
          link.href = next.href;
          link.textContent = label;
        } else {
          link.remove();
        }
        const firstLink = added[0]?.querySelector('a[href*="/products/"]');
        if (firstLink && !automatic) firstLink.focus({ preventScroll: true });
        save();
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) {
          const message = this.querySelector('[data-load-error]');
          message.textContent = this.dataset.error;
          message.hidden = false;
          this.autoPaused = true;
          link.style.removeProperty('display');
        }
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        link.removeAttribute('aria-disabled');
        link.textContent = label;
        if (this.isConnected) {
          save();
          requestAnimationFrame(() => this.autoObserve());
        }
      }
    }
  }
  customElements.define('ml-load-more', MLLoadMore);
  function save() {
    if (restoring) return;
    const container = document.getElementById('ProductGridContainer');
    const control = container?.querySelector('ml-load-more');
    if (!control || control.busy) return;
    try {
      sessionStorage.setItem(key(), JSON.stringify({ html: container.innerHTML, y: scrollY, time: Date.now() }));
    } catch {}
  }
  function restore() {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (navigation?.type !== 'back_forward') return;
    const container = document.getElementById('ProductGridContainer');
    if (!container?.querySelector('ml-load-more')) return;
    try {
      const cached = JSON.parse(sessionStorage.getItem(key()) || 'null');
      if (!cached || Date.now() - cached.time > 3600000) return;
      restoring = true;
      container.innerHTML = cached.html;
      container.querySelectorAll('.scroll-trigger').forEach(el => el.classList.add('scroll-trigger--cancel'));
      requestAnimationFrame(() => {
        scrollTo(0, cached.y);
        requestAnimationFrame(() => { scrollTo(0, cached.y); restoring = false; });
      });
    } catch { restoring = false; }
  }
  document.addEventListener('click', event => {
    if (event.target.closest('a[href*="/products/"]')) save();
  }, true);
  window.addEventListener('pagehide', save);
  document.addEventListener('DOMContentLoaded', restore, { once: true });
})();